import { render, staticRenderFns } from "./HuchaVacia.vue?vue&type=template&id=c3e719ac"
import script from "./HuchaVacia.vue?vue&type=script&lang=js"
export * from "./HuchaVacia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports